<template>
  <div class="coperation-area-box">
    <div class="show-flex-box-c">
      <dl class="show-flex-box-c">
        <dt class="show-flex-box-c">
          <span>合作学校</span>
          <strong></strong>
        </dt>
        <dd class="choose-answer show-flex-box-c">
          <strong>全区中小学校全覆盖</strong>
        </dd>
        <dd class="choose-pic-box show-flex-box-r">
          <span>
            <img src="../../assets/home/coperation_area.gif" alt="德阳经开科创" draggable="false">
          </span>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: 'coperation_area_cpn',
  data () {
    return {
      
    }
  }
}
</script>

<style lang="less" scoped>

  //公共字体样式  start
  .coperation-area-font-style( @size; @weight; @height; @color ) {
    display: block;
    font-size: @size;
    font-weight: @weight;
    line-height: @height;
    color: @color;
    word-break: break-all;
  }

  .coperation-area-box{
    width: 100%;
    background: #fff;
    &>div{
      margin: 0 auto;
      width: 1200px;
      align-items: center;
      &>dl{
        width: 100%;
        align-items: center;
        &>dt{
          align-items: center;
          &>span{
            word-wrap: none;
            .coperation-area-font-style( 40px; bold; auto; #191D21 );
            padding-top: 100px;
          }
          &>strong{
            display: block;
            width: 130px;
            height: 5px;
            background: #FF7800;
            margin-top: 19px;
            margin-bottom: 38px;
          }
        }
        &>.choose-answer{
          align-items: center;
          padding-bottom: 46px;
          &>strong{
            .coperation-area-font-style( 18px; 400; 34px; #3E3A39 );
          }
        }
        &>.choose-pic-box{
          width: 100%;
          justify-content: center;
          padding-bottom: 100px;
          &>span{
            width: 100%;
            &>img{
              display: block;
              width: 100%;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/coperation_area_cpn.vue